const reportReviewES = {
	title: "Reportar Reseña",
	subtitle: "¿Por qué estás reportando esta reseña?",
	reason: {
		spam: "Spam o falso",
		inappropriate: "Inapropiado u ofensivo",
		harassment: "Acoso o intimidación",
		incorrect: "Información incorrecta",
		other: "Otro",
	},
	placeholder: "Agrega más detalles (opcional)",
	adminSubtitle: "Describe por qué estás reportando esta reseña (opcional).",
adminPlaceholder: "Detalles adicionales (opcional)",
	actions: {
		selectReason: "Selecciona un motivo",
		selectReasonError: "Por favor selecciona un motivo antes de enviar.",
		cancel: "Cancelar",
		submit: "Enviar reporte",
		submitting: "Enviando...",
		success: "Reporte enviado.",
		error: "No se pudo enviar el reporte.",
		
		emailPlaceholder: "Tu email (opcional)", 
	},
};

export default reportReviewES;